import MainLayout from 'layouts/MainLayout';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { CommonConstant, RegexConstant, RoleTypeNameConstant } from 'constants/code.constant';
import useAccount from 'hooks/useAccount';
import React, { useEffect, useState } from 'react';
import AccountRepository from 'repositories/AccountRepository';
import CommonUtil from 'utils/common.util';

const COMPANY_TYPES = ['예비창업자', '개인사업자', '법인사업자', '조합', '기타'];
const FIELDS = [
  'AI/ICT',
  '제조/소부장',
  '스마트 모빌리티',
  '이차전지',
  '바이오/헬스',
  '반도체/디스플레이',
  '에너지',
  '문화/콘텐츠',
  '농업/임업',
  '기타',
];

const GENDER = ['남', '여'];

const defaultValues = {
  password: '',
  passwordConfirm: '',

  email: '', // 이메일(아이디)

  companyType: '', // 기업형태
  companyNumber: '', // 사업자등록번호
  corporateRegistrationNumber: '', // 법인(주민)등록번호
  corporateEstablishmentAt: '', // 법인설립일
  field: '', // 분야
  mainProduction: '', // 주요생산품
  companyHomepageLink: '', // 홈페이지 링크

  ceoName: '', // 대표자 성명
  ceoGender: '', // 대표자 성별
  ceoBirthday: '', // 대표자 생년월일
  ceoPhoneNumber: '', // 대표자 연락처
  ceoEmail: '', // 대표자 이메일

  coCeoName: '', // 공동대표자 성명
  coCeoGender: '', // 공동대표자 성별
  coCeoBirthday: '', // 공동대표자 생년월일
  coCeoPhoneNumber: '', // 공동대표자 연락처

  name: '', // 담당자 성명
  position: '', // 담당자 직급
  phoneNumber: '', // 담당자 연락처

  ventureRegistrationNumber: '', // 벤처인증번호
  ventureCertificationAt: '', // 벤처인증일
};

let schemeObject = {
  // email: yup
  //     .string()
  //     .trim()
  //     .required('이메일을 입력해 주세요')
  //     .matches(RegexConstant.email, '이메일 형식이 올바르지 않습니다'),
  // name: yup.string().trim().required('담당자 성명을 입력해 주세요'),
};

const schemeObjectPw = {
  password: yup.string().required('새 비밀번호를 입력해 주세요'),
  passwordConfirm: yup
    .string()
    .required('새 비밀번호를 확인해 주세요')
    .oneOf([yup.ref('password'), null], '새 비밀번호가 일치하지 않습니다'),
};

const MyPage = () => {
  const [isChangePassword, setIsChangePassword] = useState(false);

  if (isChangePassword) {
    schemeObject = { ...schemeObject, ...schemeObjectPw };
  }

  const schema = yup.object().shape(schemeObject);

  const {
    control,
    handleSubmit,
    getValues,
    reset,
    formState: { errors },
  } = useForm({ defaultValues, mode: 'onBlur', resolver: yupResolver(schema) });

  const [salesList, setSalesList] = useState([]); // 매출 목록
  const [employmentList, setEmploymentList] = useState([]); // 고용 목록
  const [investmentList, setInvestmentList] = useState([]); // 투자 목록
  const [patentList, setPatentList] = useState([]); // 특허 목록

  const { useGetMyAccount } = useAccount();
  const { accountInfo } = useGetMyAccount();

  const saveMyAccount = (formData) => {
    AccountRepository.saveMyAccount({
      ...formData,
      salesList,
      employmentList,
      investmentList,
      patentList,
    })
      .then((res) => {
        if (res.result === CommonConstant.OK) {
          alert('저장하였습니다');
          window.location.reload();
        } else {
          console.error(res);
          alert('알 수 없는 에러 코드');
        }
      })
      .catch(CommonUtil.repoErrFunc);
  };

  useEffect(() => {
    if (accountInfo) {
      reset({ ...getValues(), ...accountInfo });

      setSalesList(accountInfo.salesList);
      setEmploymentList(accountInfo.employmentList);
      setInvestmentList(accountInfo.investmentList);
      setPatentList(accountInfo.patentList);
    }
  }, [accountInfo]);

  return (
    <MainLayout>
      <form noValidate autoComplete="off" onSubmit={handleSubmit(saveMyAccount)}>
        <div className="page-header">계정 정보</div>
        <div className="page-card">
          <div className="table-search-wrap detail-form-wrap">
            <div>
              <label>이메일(아이디)</label>
              <input type="text" value={accountInfo?.email ?? ''} disabled />
            </div>
            <div>
              <label>비밀번호 재설정</label>
              <input
                type="checkbox"
                value={isChangePassword}
                onChange={(e) => {
                  setIsChangePassword(e.target.checked);
                }}
              />
            </div>
            <div />
            {isChangePassword && (
              <>
                <Controller
                  name={'password'}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { ref, onBlur, value, onChange } }) => (
                    <div>
                      <label>새 비밀번호</label>
                      <input
                        ref={ref}
                        type="password"
                        autoComplete="off"
                        maxLength={100}
                        onBlur={onBlur}
                        value={value}
                        onChange={onChange}
                      />
                      {errors.password && <p className="error">{errors.password.message}</p>}
                    </div>
                  )}
                />
                <div />
                <Controller
                  name={'passwordConfirm'}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { ref, onBlur, value, onChange } }) => (
                    <div>
                      <label>새 비밀번호 확인</label>
                      <input
                        ref={ref}
                        type="password"
                        maxLength={100}
                        onBlur={onBlur}
                        value={value}
                        onChange={onChange}
                      />
                      {errors.passwordConfirm && <p className="error">{errors.passwordConfirm.message}</p>}
                    </div>
                  )}
                />
              </>
            )}
          </div>
        </div>
        <br />
        <div className="page-header">기업 기본 정보</div>
        <div className="page-card">
          <div className="table-search-wrap detail-form-wrap">
            <div>
              <label>권한유형</label>
              <input type="text" value={RoleTypeNameConstant[accountInfo?.roleType] ?? ''} disabled />
            </div>
            <div>
              <label>기업명</label>
              <input type="text" value={accountInfo?.company ?? ''} disabled />
            </div>
            <Controller
              name={'companyType'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>기업형태</label>
                  <select value={value} onChange={onChange} onBlur={onBlur}>
                    <option value="">선택</option>
                    {COMPANY_TYPES.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            />
            <Controller
              name={'companyNumber'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>사업자등록번호</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={50} />
                </div>
              )}
            />
            <Controller
              name={'corporateRegistrationNumber'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>법인(주민)등록번호</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={50} />
                </div>
              )}
            />
            <Controller
              name={'corporateEstablishmentAt'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>법인설립일</label>
                  <input
                    type="date"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
              )}
            />
            <Controller
              name={'field'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>분야</label>
                  <select value={value} onChange={onChange} onBlur={onBlur}>
                    <option value="">선택</option>
                    {FIELDS.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            />
            <Controller
              name={'mainProduction'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>주요생산품</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={100} />
                </div>
              )}
            />
            <Controller
              name={'companyHomepageLink'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>홈페이지 링크</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={200} />
                </div>
              )}
            />
          </div>
        </div>
        <br />
        <div className="page-header">대표자 정보</div>
        <div className="page-card">
          <div className="table-search-wrap detail-form-wrap">
            <Controller
              name={'ceoName'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>대표자 성명</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={50} />
                </div>
              )}
            />
            <Controller
              name={'ceoGender'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>대표자 성별</label>
                  <select value={value} onChange={onChange} onBlur={onBlur}>
                    <option value="">선택</option>
                    {GENDER.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            />
            <Controller
              name={'ceoBirthday'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>대표자 생년월일</label>
                  <input
                    type="date"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
              )}
            />
            <Controller
              name={'ceoPhoneNumber'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>대표자 연락처</label>
                  <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="'-' 포함"
                    maxLength={20}
                  />
                </div>
              )}
            />
            <Controller
              name={'ceoEmail'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>대표자 이메일</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={100} />
                </div>
              )}
            />
            <div />
            <div />
            <div />
            <Controller
              name={'coCeoName'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>공동대표자 성명</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={50} />
                </div>
              )}
            />
            <Controller
              name={'coCeoGender'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>공동대표자 성별</label>
                  <select value={value} onChange={onChange} onBlur={onBlur}>
                    <option value="">선택</option>
                    {GENDER.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            />
            <Controller
              name={'coCeoBirthday'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>공동대표자 생년월일</label>
                  <input
                    type="date"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
              )}
            />
            <Controller
              name={'coCeoPhoneNumber'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>공동대표자 연락처</label>
                  <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="'-' 포함"
                    maxLength={20}
                  />
                </div>
              )}
            />
          </div>
        </div>
        <br />
        <div className="page-header">담당자 정보</div>
        <div className="page-card">
          <div className="table-search-wrap detail-form-wrap">
            <Controller
              name={'name'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>담당자 성명</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={50} disabled />
                </div>
              )}
            />
            <Controller
              name={'position'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>담당자 직급</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={20} />
                </div>
              )}
            />
            <Controller
              name={'phoneNumber'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>담당자 연락처</label>
                  <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="'-' 포함"
                    maxLength={20}
                  />
                </div>
              )}
            />
          </div>
        </div>
        <br />
        <div className="page-header">기업성과</div>
        <div className="page-card">
          <div className="table-search-wrap detail-form-wrap">
            <Controller
              name={'ventureRegistrationNumber'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>벤처인증번호</label>
                  <input type="text" value={value} onChange={onChange} onBlur={onBlur} maxLength={50} />
                </div>
              )}
            />
            <Controller
              name={'ventureCertificationAt'}
              control={control}
              render={({ field: { onBlur, value, onChange } }) => (
                <div>
                  <label>벤처인증일</label>
                  <input
                    type="date"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
              )}
            />
            <SalesContent salesList={salesList} setSalesList={setSalesList} />
            <EmploymentContent employmentList={employmentList} setEmploymentList={setEmploymentList} />
            <InvestmentContent investmentList={investmentList} setInvestmentList={setInvestmentList} />
            <PatentContent patentList={patentList} setPatentList={setPatentList} />
          </div>
        </div>
        <br />
        <div className="display-flex space-between">
          <div />
          <button className="btn add-btn" type="submit">
            저장
          </button>
        </div>
      </form>
    </MainLayout>
  );
};

/** 매출 */
const SalesContent = React.memo(({ salesList, setSalesList }) => {
  const [inputData, setInputData] = useState({
    year: '',
    domesticSales: '',
    overseasSales: '',
  });

  const onChangeValue = (key, value) => {
    const onlyNumber = value.replace(/[^0-9]/g, '').replace(/^0+/, '');

    setInputData((prev) => ({
      ...prev,
      [key]: onlyNumber,
    }));
  };

  const addSales = () => {
    const { year, domesticSales, overseasSales } = inputData;
    if (!year.trim()) {
      alert('년도를 입력해 주세요');
      return;
    }

    const newData = {
      year,
      domesticSales: parseInt(domesticSales),
      overseasSales: parseInt(overseasSales),
    };

    setSalesList((prev) => [...prev, newData]);
    setInputData({ year: '', domesticSales: '', overseasSales: '' });
  };

  const removeSales = (salesId, index) => {
    setSalesList((prev) => {
      if (salesId) {
        return prev.map((item) => (item.salesId === salesId ? { ...item, isDeleted: true } : item));
      } else {
        return prev.filter((_, i) => i !== index);
      }
    });
  };

  const totalSalesAmount = salesList.reduce(
    (acc, sale) => (sale.isDeleted ? acc : acc + (sale.domesticSales + sale.overseasSales)),
    0,
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <h3>매출</h3>
      <div
        style={{
          border: '1px solid #888888',
          padding: '5px 10px',
          borderRadius: '10px',
        }}
      >
        <h4>총 매출: {CommonUtil.tsCommaFormat(totalSalesAmount)}원</h4>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '20px',
            margin: '20px 0',
          }}
        >
          <div>
            <label>년도</label>
            <input
              type="text"
              value={inputData.year}
              onChange={(e) => onChangeValue('year', e.target.value)}
              maxLength={4}
            />
          </div>
          <div>
            <label>국내(원)</label>
            <input
              type="text"
              value={inputData.domesticSales}
              onChange={(e) => onChangeValue('domesticSales', e.target.value)}
            />
          </div>
          <div>
            <label>해외(원)</label>
            <input
              type="text"
              value={inputData.overseasSales}
              onChange={(e) => onChangeValue('overseasSales', e.target.value)}
            />
          </div>
          <button className="btn add-btn" type="button" onClick={addSales}>
            추가
          </button>
        </div>
        <div className="table-wrap">
          <table
            style={{
              margin: 0,
            }}
          >
            <thead>
              <tr>
                <td width={150}>년도</td>
                <td width={150}>국내(원)</td>
                <td width={150}>해외(원)</td>
                <td width={150}>합계(원)</td>
                <td width={150}>비고</td>
              </tr>
            </thead>
            <tbody>
              {salesList.filter((item) => !item.isDeleted).length === 0 && (
                <tr>
                  <td colSpan={5}>결과가 없습니다.</td>
                </tr>
              )}
              {salesList
                .filter((item) => !item.isDeleted)
                .map((item, index) => (
                  <tr key={index}>
                    <td>{item.year}</td>
                    <td>{CommonUtil.tsCommaFormat(item.domesticSales)}</td>
                    <td>{CommonUtil.tsCommaFormat(item.overseasSales)}</td>
                    <td>{CommonUtil.tsCommaFormat(parseInt(item.domesticSales) + parseInt(item.overseasSales))}</td>
                    <td>
                      <button className="btn error-btn" type="button" onClick={() => removeSales(item.salesId, index)}>
                        삭제
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

/** 고용 */
const EmploymentContent = React.memo(({ employmentList, setEmploymentList }) => {
  const [inputData, setInputData] = useState({
    year: '',
    permanentEmployees: '',
    temporaryEmployees: '',
  });

  const onChangeValue = (key, value) => {
    const onlyNumber = value.replace(/[^0-9]/g, '').replace(/^0+/, '');

    setInputData((prev) => ({
      ...prev,
      [key]: onlyNumber,
    }));
  };

  const addEmployment = () => {
    const { year, permanentEmployees, temporaryEmployees } = inputData;
    if (!year.trim()) {
      alert('년도를 입력해 주세요');
      return;
    }

    const newData = {
      year,
      permanentEmployees: parseInt(permanentEmployees),
      temporaryEmployees: parseInt(temporaryEmployees),
    };

    setEmploymentList((prev) => [...prev, newData]);
    setInputData({ year: '', permanentEmployees: '', temporaryEmployees: '' });
  };

  const removeEmployment = (employmentId, index) => {
    setEmploymentList((prev) => {
      if (employmentId) {
        return prev.map((item) => (item.employmentId === employmentId ? { ...item, isDeleted: true } : item));
      } else {
        return prev.filter((_, i) => i !== index);
      }
    });
  };

  const totalEmployees = employmentList.reduce(
    (acc, employee) => (employee.isDeleted ? acc : acc + (employee.permanentEmployees + employee.temporaryEmployees)),
    0,
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <h3>고용 (4대보험 가입 기준 / 대표자 제외)</h3>
      <div
        style={{
          border: '1px solid #888888',
          padding: '5px 10px',
          borderRadius: '10px',
        }}
      >
        <h4>총 인원: {CommonUtil.tsCommaFormat(totalEmployees)}명</h4>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '20px',
            margin: '20px 0',
          }}
        >
          <div>
            <label>년도</label>
            <input
              type="text"
              value={inputData.year}
              onChange={(e) => onChangeValue('year', e.target.value)}
              maxLength={4}
            />
          </div>
          <div>
            <label>정규직(명)</label>
            <input
              type="text"
              value={inputData.permanentEmployees}
              onChange={(e) => onChangeValue('permanentEmployees', e.target.value)}
            />
          </div>
          <div>
            <label>비정규직(명)</label>
            <input
              type="text"
              value={inputData.temporaryEmployees}
              onChange={(e) => onChangeValue('temporaryEmployees', e.target.value)}
            />
          </div>
          <button className="btn add-btn" type="button" onClick={addEmployment}>
            추가
          </button>
        </div>
        <div className="table-wrap">
          <table
            style={{
              margin: 0,
            }}
          >
            <thead>
              <tr>
                <td width={150}>년도</td>
                <td width={150}>정규직(명)</td>
                <td width={150}>비정규직(명)</td>
                <td width={150}>합계(명)</td>
                <td width={150}>비고</td>
              </tr>
            </thead>
            <tbody>
              {employmentList.filter((item) => !item.isDeleted).length === 0 && (
                <tr>
                  <td colSpan={5}>결과가 없습니다.</td>
                </tr>
              )}
              {employmentList
                .filter((item) => !item.isDeleted)
                .map((item, index) => (
                  <tr key={index}>
                    <td>{item.year}</td>
                    <td>{CommonUtil.tsCommaFormat(item.permanentEmployees)}</td>
                    <td>{CommonUtil.tsCommaFormat(item.temporaryEmployees)}</td>
                    <td>
                      {CommonUtil.tsCommaFormat(parseInt(item.permanentEmployees) + parseInt(item.temporaryEmployees))}
                    </td>
                    <td>
                      <button
                        className="btn error-btn"
                        type="button"
                        onClick={() => removeEmployment(item.employmentId, index)}
                      >
                        삭제
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

/** 투자 */
const InvestmentContent = React.memo(({ investmentList, setInvestmentList }) => {
  const [inputData, setInputData] = useState({
    year: '',
    investmentAmount: '',
    investor: '',
  });

  const onChangeValue = (key, value) => {
    let formattedValue = '';

    if (key !== 'investor') {
      formattedValue = value.replace(/[^0-9]/g, '').replace(/^0+/, '');
    } else {
      formattedValue = value;
    }

    setInputData((prev) => ({
      ...prev,
      [key]: formattedValue,
    }));
  };

  const addInvestment = () => {
    const { year, investmentAmount, investor } = inputData;
    if (!year.trim()) {
      alert('년도를 입력해 주세요');
      return;
    }

    const newData = {
      year,
      investmentAmount: parseInt(investmentAmount),
      investor,
    };

    setInvestmentList((prev) => [...prev, newData]);
    setInputData({ year: '', investmentAmount: '', investor: '' });
  };

  const removeInvestment = (investmentId, index) => {
    setInvestmentList((prev) => {
      if (investmentId) {
        return prev.map((item) => (item.investmentId === investmentId ? { ...item, isDeleted: true } : item));
      } else {
        return prev.filter((_, i) => i !== index);
      }
    });
  };

  const totalInvestmentAmount = investmentList.reduce(
    (acc, investment) => (investment.isDeleted ? acc : acc + investment.investmentAmount),
    0,
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <h3>투자</h3>
      <div
        style={{
          border: '1px solid #888888',
          padding: '5px 10px',
          borderRadius: '10px',
        }}
      >
        <h4>총 투자 금액: {CommonUtil.tsCommaFormat(totalInvestmentAmount)}원</h4>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '20px',
            margin: '20px 0',
          }}
        >
          <div>
            <label>년도</label>
            <input
              type="text"
              value={inputData.year}
              onChange={(e) => onChangeValue('year', e.target.value)}
              maxLength={4}
            />
          </div>
          <div>
            <label>투자금액(원)</label>
            <input
              type="text"
              value={inputData.investmentAmount}
              onChange={(e) => onChangeValue('investmentAmount', e.target.value)}
            />
          </div>
          <div>
            <label>투자자</label>
            <input type="text" value={inputData.investor} onChange={(e) => onChangeValue('investor', e.target.value)} />
          </div>
          <button className="btn add-btn" type="button" onClick={addInvestment}>
            추가
          </button>
        </div>
        <div className="table-wrap">
          <table
            style={{
              margin: 0,
            }}
          >
            <thead>
              <tr>
                <td width={150}>년도</td>
                <td width={150}>투자금액(원)</td>
                <td width={150}>투자자</td>
                <td width={150}>비고</td>
              </tr>
            </thead>
            <tbody>
              {investmentList.filter((item) => !item.isDeleted).length === 0 && (
                <tr>
                  <td colSpan={4}>결과가 없습니다.</td>
                </tr>
              )}
              {investmentList
                .filter((item) => !item.isDeleted)
                .map((item, index) => (
                  <tr key={index}>
                    <td>{item.year}</td>
                    <td>{CommonUtil.tsCommaFormat(item.investmentAmount)}</td>
                    <td>{item.investor}</td>
                    <td>
                      <button
                        className="btn error-btn"
                        type="button"
                        onClick={() => removeInvestment(item.investmentId, index)}
                      >
                        삭제
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

/** 특허 */
const PatentContent = React.memo(({ patentList, setPatentList }) => {
  const [inputData, setInputData] = useState({
    patentType: '',
    patentStatus: '',
    patentNumber: '',
    patentName: '',
  });

  const onChangeValue = (key, value) => {
    setInputData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const addPatent = () => {
    const { patentType, patentStatus, patentNumber, patentName } = inputData;
    if (!patentType) {
      alert('특허 유형을 선택해 주세요');
      return;
    }

    if (!patentStatus) {
      alert('특허 상태를 선택해 주세요');
      return;
    }

    const newData = {
      patentType,
      patentStatus,
      patentNumber,
      patentName,
    };

    setPatentList((prev) => [...prev, newData]);
    setInputData({ patentType: '', patentStatus: '', patentNumber: '', patentName: '' });
  };

  const removePatent = (patentId, index) => {
    setPatentList((prev) => {
      if (patentId) {
        return prev.map((item) => (item.patentId === patentId ? { ...item, isDeleted: true } : item));
      } else {
        return prev.filter((_, i) => i !== index);
      }
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <h3>특허</h3>
      <div
        style={{
          border: '1px solid #888888',
          padding: '5px 10px',
          borderRadius: '10px',
        }}
      >
        <h4>총 특허 수: {CommonUtil.tsCommaFormat(patentList.filter((item) => !item.isDeleted).length)}개</h4>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            alignItems: 'flex-end',
            gap: '20px',
            margin: '20px 0',
          }}
        >
          <div>
            <label>특허 유형</label>
            <select value={inputData.patentType} onChange={(e) => onChangeValue('patentType', e.target.value)}>
              <option value="">선택</option>
              <option value="국내">국내</option>
              <option value="해외">해외</option>
            </select>
          </div>
          <div>
            <label>특허 상태</label>
            <select value={inputData.patentStatus} onChange={(e) => onChangeValue('patentStatus', e.target.value)}>
              <option value="">선택</option>
              <option value="특허출원">특허출원</option>
              <option value="특허등록">특허등록</option>
              <option value="상표출원">상표출원</option>
              <option value="상표등록">상표등록</option>
            </select>
          </div>
          <div>
            <label>출원 번호</label>
            <input
              type="text"
              value={inputData.patentNumber}
              onChange={(e) => onChangeValue('patentNumber', e.target.value)}
            />
          </div>
          <div>
            <label>특허명</label>
            <input
              type="text"
              value={inputData.patentName}
              onChange={(e) => onChangeValue('patentName', e.target.value)}
            />
          </div>
          <div>
            <button className="btn add-btn" type="button" onClick={addPatent}>
              추가
            </button>
          </div>
        </div>
        <div className="table-wrap">
          <table
            style={{
              margin: 0,
            }}
          >
            <thead>
              <tr>
                <td width={150}>특허 유형</td>
                <td width={150}>특허 상태</td>
                <td width={150}>출원 번호</td>
                <td width={150}>특허명</td>
                <td width={150}>비고</td>
              </tr>
            </thead>
            <tbody>
              {patentList.filter((item) => !item.isDeleted).length === 0 && (
                <tr>
                  <td colSpan={5}>결과가 없습니다.</td>
                </tr>
              )}
              {patentList
                .filter((item) => !item.isDeleted)
                .map((item, index) => (
                  <tr key={index}>
                    <td>{item.patentType}</td>
                    <td>{item.patentStatus}</td>
                    <td>{item.patentNumber}</td>
                    <td>{item.patentName}</td>
                    <td>
                      <button
                        className="btn error-btn"
                        type="button"
                        onClick={() => removePatent(item.patentId, index)}
                      >
                        삭제
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

export default MyPage;
